export enum selectOptionTypes {
  noGroup = 'noGroup',
}
